import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import axios from "axios";
import { apiUrl } from "../../../constants";
import Dropdown2 from "../dropdown2/Dropdown2";

const Category = ({ control, register, errors }) => {
  const [result, setResult] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function getAll() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(`${apiUrl}/api/formsettings/category`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setResult(data);
      } catch (e) {
        console.error(e);
        if (e.response !== undefined) {
          console.error(e.response.data.message);
        }
      }
    }
    getAll();
  }, []);

  useEffect(() => {
    const options = [];
    result.forEach((currentCategory) => {
      const newOption = {
        label: currentCategory.category,
        value: currentCategory.category,
      };
      options.push(newOption);
    });
    setOptions(
      options.sort((a, b) =>
        a.value === b.value ? 0 : a.value < b.value ? -1 : 1
      )
    );
  }, [result]);

  return (
    <section className="category-wrapper">
      <div>
        <Controller
          control={control}
          name="category"
          render={({ field: { onChange, value } }) => (
            <Dropdown2
              label="Category * "
              options={options}
              name="category"
              value={value}
              onChange={onChange}
              fieldRef={register("category", { required: true })}
            />
          )}
        />
      </div>
    </section>
  );
};

export default Category;
